export default __webpack_public_path__ + "static/media/Armguards of Indomitable Souls.d65e2f63.jpg";